export const FILES_UPDATED = 'FILES_UPDATED'

export const FILES_UPLOAD_STARTED = 'FILES_UPLOAD_STARTED'
export const FILES_UPLOAD_OK = 'FILES_UPLOAD_OK'
export const FILES_UPLOAD_ERROR = 'FILES_UPLOAD_ERROR'

export const UPLOAD_PROGRESS_UPDATED = 'UPLOAD_PROGRESS_UPDATED'

export const FILE_DOWNLOAD_RECEIVED = 'FILE_DOWNLOAD_RECEIVED'
export const FILE_DOWNLOAD_ERROR = 'FILE_DOWNLOAD_ERROR'